import styles from './Modal.module.scss';

// import example_photo from 'images/example-screen-photo.jpg';
import { Modal } from '@mantine/core';
import { IconBoxAlignRight, IconDeviceMobile, IconRulerMeasure, IconZoomCancel } from '@tabler/icons-react';

interface InstructionModalProps {
    opened: boolean;
    close: () => void;
    onButtonClick: () => void;
    label?: string;
}

const InstructionModal = ({ opened, close, onButtonClick, ...rest }: InstructionModalProps) => {

    const PhotoDiagram = () => {
        return (
            <div className={styles.photoDiagram}>
                <img src={'/images/example-screen.jpg'} alt={"Example Photo of Aperture"} className={styles.examplePhoto} />
                <div className={styles.photoDescription}>
                    {/* Create a grid with 3 rows and two columns. Each cell on the left had an icon each box on the right has a few words of text */}
                    <div className={styles.photoDescription}>
                        <div className={styles.photoDescriptionRow}>
                            <IconRulerMeasure size={24} />
                            <p>~ 30 cm away</p>
                        </div>
                        <div className={styles.photoDescriptionRow}>
                            <IconDeviceMobile size={24} />
                            <p>Portrait Mode</p>
                        </div>
                        <div className={styles.photoDescriptionRow}>
                            <IconZoomCancel size={24} />
                            <p>No Zoom</p>
                        </div>
                        <div className={styles.photoDescriptionRow}>
                            <IconBoxAlignRight size={24} />
                            <p>Parallel to Screen</p>
                        </div>
                    </div>

                </div>
            </div>

        );
    }


    return (
        <Modal opened={opened} onClose={close} title="How to use the App">
            <div className={styles.modal}>
                {/* <h2>Scanning Apertures</h2> */}
                <div className={styles.textContainer}>
                    <ol className={styles.textList}>
                        <li>Fill out the details at the top of the page</li>
                        <li><b>Baseline Aperture Width</b> refers to the standard size of the gap between bars in a brand new screen.</li>
                        <li>Tap <b>New Photo</b> to open the camera. Line the screen up inside the frame and hold your phone <b>upright</b> (vertical, facing the screen) — the guide turns green when you're square-on.</li>
                        <li>After the shutter, blurry or dark shots prompt a <b>retake</b> before uploading.</li>
                        <li>Take 2-5 photos of the screen and check the results.</li>
                        <li>Once finished press “Confirm Measurements” at the bottom.</li>
                    </ol>
                </div>
                <PhotoDiagram />
                {/* <img src={'/images/example-screen.jpg'} alt={"Example Photo of Aperture"} className={styles.examplePhoto} /> */}
            </div>
        </Modal>

    );
};

export default InstructionModal;
